import { RootState } from '@reducers';

export const selectPersonalAccidentQuoteComparePage = (state: RootState) =>
  state.personalAccidentQuoteComparePageReducer;
